'use strict';

class Comparison {
    constructor() {
        this.addToComparisonButton = '.add-to-comparison';
        this.removeFromComparisonButton = '.remove-from-comparison';
        this.comparisonCounter = '.comparison-counter';
        this.isPreviousRequestResolved = true;
    }

    setUpListeners() {
        $(document).on('click', this.addToComparisonButton, event => {
            if (this.isPreviousRequestResolved) {
                this.isPreviousRequestResolved = false;
                this.handleNewElement(event)
            }
        });
        $(document).on('click', this.removeFromComparisonButton, event => {
            if (this.isPreviousRequestResolved) {
                this.isPreviousRequestResolved = false;
                this.handleRemoveElement(event);
            }
        });

        return this;
    }

    setModal(modal) {
        this.modal = modal;
        return this;
    }

    handleNewElement(event) {
        const element = $(event.target);
        let self = this;
        $.ajax({
            url: element.data('url'),
            type: 'get',
        }).done(function (response) {
            self.renderComparisonModelButton(response.count);
            $('#add-to-comparison-' + response.id).html(response.btnContent)
                .closest('.add_to_comparison').addClass('in_comparison');
            self.isPreviousRequestResolved = true;
        }).fail(function () {
            self.isPreviousRequestResolved = true;
        });

    }

    handleRemoveElement(event) {
        let self = this;
        const element = $(event.target);
        $.ajax({
            url: element.data('url'),
            type: 'get',
        }).done(function (response) {
            self.renderComparisonModelButton(response.count);
            $('#add-to-comparison-' + response.id).html(response.btnContent)
                .closest('.add_to_comparison').removeClass('in_comparison');
            $('#comparison-content').trigger('comparison.renderContent', [response.content]);
            self.isPreviousRequestResolved = true;
        }).fail(function () {
            self.isPreviousRequestResolved = true;
        });
    }

    renderComparisonModelButton(count) {
        $(this.comparisonCounter).html(count)
    }
}

export default Comparison;


// WEBPACK FOOTER //
// ./assets/js/utils/comparison.js